import React from "react";
import { Form, InputNumber, Row, Col, Typography } from "antd";
const { Text } = Typography;

const VitalsAdmission = ({ op = false }) => {
  return (
    <>
      <Text strong>{op ? "Vitals" : "Vitals at the time of Admission"}</Text>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} >
          <Form.Item name="temperature" label="Temperature">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="°F"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} >

          <Form.Item name="pulse_rate" label="Pulse Rate">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="beats/min"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} >
          <Form.Item name="respiratory_rate" label="Respiratory Rate">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="breaths/min"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>

          <Form.Item name="systolic_bp" label="Systolic BP">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="mmHg"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Form.Item name="diastolic_bp" label="Diastolic BP">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="mmHg"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Form.Item name="spo2" label="SpO2">
            <InputNumber
              className="gen-exam-vital-input"
              addonAfter="%"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default VitalsAdmission;
